import { useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  BriefcaseMedical,
  Car,
  ClipboardPlus,
  HandCoins,
  IdCard,
  Flame,
  HeartHandshake,
  Calculator,
  PiggyBank,
  Pill,
  UsersRound,
  Baby,
  Newspaper,
} from "lucide-react";

const PRODUCT_CARDS = [
  {
    title: "종신보험",
    description:
      "종신보험이란 피보험자의 평생을 담보해 사망하게 되면 보험금을 100% 지급하는 상품입니다.",
    detail:
      "즉, 사망의 시기와 원인을 확인후 특별한 사유 (자살 등) 외에는 무조건 보험금을 지급하는 상품을 말합니다.",
    icon: Newspaper,
  },
  {
    title: "암보험",
    description:
      "막대한 치료비가 드는 암질환을 종합적으로 보장받을 수 있는 생명보험상품의 하나입니다.",
    detail:
      "이 보험의 피보험자는 본인뿐 아니라 배우자나 자녀도 종피보험자가 될 수 있기 때문에 일가족 전원을 무진단으로 보장받을 수 있는 보장성 암보험입니다.",
    icon: BriefcaseMedical,
  },
  {
    title: "태아보험",
    description:
      "어린이를 피보험자로 하고 부모를 보험계약자로 하는 생명보험계약을 말합니다.",
    detail:
      "어린이의 교육, 결혼자금 등의 준비에 이용되는 일이 많으며, 만기 때에 만기보험금이 지급되는 것 이외에 어린이가 일정 연령에 이를 때마다 입학 축하금이 지급되기도 합니다.",
    icon: Baby,
  },
  {
    title: "CI/GI 보험",
    description:
      "종신(정기) 보험 형태로써 암, 심근경색, 5대 장기이식수술 등 고액의 치료비가 드는 치명적 질병 발병 시에 사망보험금의 50~100%를 선지급하고 사망 시에는 잔액(보험가입금액-선지급금액)을 지급하는 보험을 말합니다.",
    detail: "",
    icon: ClipboardPlus,
  },
  {
    title: "변액보험",
    description:
      "계약자가 낸 보험료의 일부를 수익성 높은 유가 증권에 투자하여 그 수익금을 계약자에게 나누어 주는 보험 상품을 말하며 투자 수익에 따라 보험금 액수가 달라지게 됩니다.",
    detail: "",
    icon: Calculator,
  },
  {
    title: "연금보험",
    description:
      "피보험자의 종신 또는 일정 기간 동안 정해진 금액을 받을 수 있는 생명보험으로 은퇴 후 필요한 생활비를 마련할 수 있는 상품입니다.",
    detail: "",
    icon: HandCoins,
  },
  {
    title: "저축보험",
    description:
      "3년·5년 또는 10년 등 비교적 단기간의 저축을 목적으로 하는 보험을 말합니다.",
    detail: "",
    icon: PiggyBank,
  },
  {
    title: "간병보험",
    description:
      "노년생활보호를 목적으로 한 보험으로 자식들이 대신 가입하는 경우가 많기 때문에 효도보험이라고도 하고, 입원비와 치료비는 물론 부모님의 거동이 불편할 때 간병 자금이나 치매에 따른 진단금까지 보장을 받을 수 있습니다.",
    detail: "",
    icon: HeartHandshake,
  },
  {
    title: "실버보험",
    description:
      "실버보험은 고령자(주로 만 50~70세 이상)를 대상으로 노년기 질병, 간병, 치매 등 노후 위험에 대비해 가입하는 보험 상품 입니다.",
    detail: "",
    icon: UsersRound,
  },
  {
    title: "자동차보험",
    description:
      "자동차보험은 피보험자가 자동차를 소유, 사용 또는 관리하는 동안에 발생하는 사고로 인하여 피보험자에게 생긴 손해를 보험자가 보상하는 보험입니다.",
    detail: "",
    icon: Car,
  },
  {
    title: "운전자보험",
    description:
      "운전자 보험이란 차량을 운전하는 사람이 교통사로 발생 시 입게 되는 손해를 복구하기 위하여 운전자의 손해를 보전하기 위하여 필요한 보험입니다.",
    detail: "",
    icon: IdCard,
  },
  {
    title: "화재보험",
    description:
      "화재보험은 화재로 인한 재산 손해를 보상하는 손해보험입니다. 보험자는 화재 발생 시 건물, 동산, 시설물 등의 손해를 보상하며, 보험계약자는 보험료를 납부해 위험을 전가합니다.",
    detail: "",
    icon: Flame,
  },
  {
    title: "유병자보험",
    description:
      "유병자보험은 질병을 앓았거나 병력이 있는 소비자가 간소화된 심사 절차를 통해 가입할 수 있는 보험상품입니다.",
    detail:
      "일반 보험보다 가입 요건이 완화되었으나, 보장 범위가 좁고 보험료가 2~5배 비싼 특징이 있습니다.",
    icon: Pill,
  },
];

function chunkCards(cards, size) {
  const result = [];
  for (let i = 0; i < cards.length; i += size) {
    result.push(cards.slice(i, i + size));
  }
  return result;
}

function ProductIcon({ icon: Icon, className = "", strokeWidth = 1.6 }) {
  return (
    <div
      className={["relative flex items-center justify-center", className].join(
        " ",
      )}
    >
      <div className="absolute inset-0 rounded-full bg-[linear-gradient(135deg,rgba(255,150,1,0.28),rgba(24,45,95,0.22))] blur-[1px]" />

      <div className="relative flex h-full w-full items-center justify-center rounded-full border border-[rgba(24,45,95,0.12)] bg-white/92 backdrop-blur-sm">
        <Icon
          className="h-[58%] w-[58%] text-secondary"
          strokeWidth={strokeWidth}
        />
      </div>
    </div>
  );
}

function ProductCard({ item, featured = false }) {
  return (
    <article
      className={[
        "group relative overflow-hidden border border-[#dddddd] bg-white transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(0,0,0,0.06)]",
        featured
          ? "min-h-[320px] px-7 py-8 sm:px-8 sm:py-9 lg:min-h-[340px]"
          : "min-h-[300px] px-6 py-7 sm:px-7 sm:py-8 lg:min-h-[320px]",
      ].join(" ")}
    >
      <div className={featured ? "max-w-[88%]" : "max-w-[86%]"}>
        <h2
          className={[
            "font-extrabold tracking-[-0.04em] text-secondary",
            featured
              ? "text-[28px] sm:text-[30px]"
              : "text-[25px] sm:text-[27px]",
          ].join(" ")}
        >
          {item.title}
        </h2>

        <p
          className={[
            "tracking-[-0.02em] text-gray-600",
            featured
              ? "mt-4 text-[16px] leading-[1.8] sm:text-[17px]"
              : "mt-4 text-[15px] leading-[1.85] sm:text-[16px]",
          ].join(" ")}
        >
          {item.description}
        </p>

        {item.detail ? (
          <p
            className={[
              "tracking-[-0.02em] text-gray-500",
              featured
                ? "mt-3 text-[14px] leading-[1.8] sm:text-[15px]"
                : "mt-3 text-[14px] leading-[1.8]",
            ].join(" ")}
          >
            {item.detail}
          </p>
        ) : null}
      </div>

      <div
        className={[
          "absolute bottom-5 right-5 sm:bottom-6 sm:right-6",
          featured
            ? "h-[68px] w-[68px] sm:h-[74px] sm:w-[74px]"
            : "h-[60px] w-[60px] sm:h-[66px] sm:w-[66px]",
        ].join(" ")}
      >
        <ProductIcon
          icon={item.icon}
          className="h-full w-full"
          strokeWidth={1.55}
        />
      </div>
    </article>
  );
}

export default function InsuranceProductsPage() {
  const navigate = useNavigate();

  const firstCard = PRODUCT_CARDS[0];
  const groupedCards = chunkCards(PRODUCT_CARDS.slice(1), 3);

  return (
    <main className="min-h-screen bg-white">
      <section className="mx-auto max-w-[1400px] px-5 pb-16 pt-10 sm:px-8 sm:pb-20 sm:pt-12 md:px-12 lg:pb-24 lg:pt-14 xl:px-16">
        <div className="self-start flex w-full flex-row items-center gap-2.5 sm:gap-3 md:gap-4 mb-6">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex shrink-0 items-center text-secondary"
            aria-label="이전 페이지로 이동"
          >
            <ChevronLeft className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8" />
          </button>

          <h1 className="text-[28px] font-extrabold leading-[1.2] tracking-[-0.04em] text-secondary sm:text-[34px] md:text-[40px] lg:text-[42px] xl:text-[46px]">
            보험 상품
          </h1>
        </div>

        <div className="space-y-6 sm:space-y-7 lg:space-y-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
            <div className="xl:col-start-3">
              <ProductCard item={firstCard} />
            </div>
          </div>

          {groupedCards.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3"
            >
              {row.map((item) => (
                <ProductCard key={item.title} item={item} />
              ))}
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
